import { useState } from 'react';

const countries = [
  {
    id: 1,
    name: 'Brazil',
    tagline: 'Jungle, beaches & carnival',
    description: 'Discover the magic of the Amazon, the beaches of Rio de Janeiro and the vibrant Brazilian culture.',
    image: 'https://public.readdy.ai/ai/img_res/635128c3a36920a848682d1ba5182149.jpg',
    highlights: ['Rio de Janeiro', 'Amazon', 'Iguazú Falls'],
    color: 'from-green-800/80 to-yellow-700/60',
    accent: 'bg-yellow-400',
    textAccent: 'text-yellow-400',
  },
  {
    id: 2,
    name: 'Argentina',
    tagline: 'Patagonia, tango & wine',
    description: 'Explore the glaciers of Patagonia, the vineyards of Mendoza and the passionate Buenos Aires tango.',
    image: 'https://readdy.ai/api/search-image?query=Buenos%20Aires%20Obelisco%20iconic%20white%20obelisk%20monument%20at%20night%20illuminated%20city%20lights%20wide%20avenue%20Avenida%209%20de%20Julio%20Argentina%20urban%20landmark%20dramatic%20sky%20long%20exposure%20photography&width=800&height=600&seq=argentina-obelisco-bsas-02&orientation=landscape',
    highlights: ['Buenos Aires', 'Patagonia', 'Mendoza'],
    color: 'from-sky-900/80 to-white/10',
    accent: 'bg-sky-400',
    textAccent: 'text-sky-300',
  },
  {
    id: 3,
    name: 'Peru',
    tagline: 'History, culture & adventure',
    description: 'Walk through the ruins of Machu Picchu, sail Lake Titicaca and taste the world\'s finest cuisine.',
    image: 'https://readdy.ai/api/search-image?query=Machu%20Picchu%20ancient%20Inca%20citadel%20Peru%20with%20a%20fluffy%20llama%20standing%20in%20the%20foreground%20looking%20at%20camera%2C%20dramatic%20misty%20mountain%20peaks%20in%20background%2C%20lush%20green%20terraces%2C%20mystical%20morning%20atmosphere%2C%20golden%20sunlight%20breaking%20through%20clouds%2C%20iconic%20UNESCO%20world%20heritage%20site%2C%20stunning%20Andean%20landscape%20with%20vibrant%20colors&width=800&height=600&seq=peru-llama-machupicchu-05&orientation=landscape',
    highlights: ['Machu Picchu', 'Cusco', 'Lake Titicaca'],
    color: 'from-amber-900/80 to-red-800/60',
    accent: 'bg-amber-400',
    textAccent: 'text-amber-400',
  },
];

export default function SouthAmericaBanner() {
  const [active, setActive] = useState(0);

  const current = countries[active];

  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-teal-600 text-sm font-semibold tracking-widest uppercase mb-3">
            Explore South America
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Unforgettable Journeys to the End of the World
          </h2>
          <div className="w-20 h-1 bg-teal-600 mx-auto"></div>
        </div>

        {/* Country selector */}
        <div className="flex justify-center gap-3 md:gap-6 mb-8">
          {countries.map((country, idx) => (
            <button
              key={country.id}
              onClick={() => setActive(idx)}
              className={`px-5 md:px-8 py-2.5 rounded-full text-sm md:text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer border-2 ${
                active === idx
                  ? 'bg-teal-600 text-white border-teal-600 shadow-lg scale-105'
                  : 'bg-white text-gray-700 border-gray-200 hover:border-teal-400 hover:text-teal-600'
              }`}
            >
              {country.name}
            </button>
          ))}
        </div>

        {/* Main banner */}
        <div className="relative rounded-3xl overflow-hidden shadow-2xl h-[420px] md:h-[520px]">
          {countries.map((country, idx) => (
            <div
              key={country.id}
              className={`absolute inset-0 transition-opacity duration-700 ${
                active === idx ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img
                src={country.image}
                alt={country.name}
                className="w-full h-full object-cover object-top"
              />
              <div className={`absolute inset-0 bg-gradient-to-r ${country.color}`}></div>
            </div>
          ))}

          {/* Content */}
          <div className="relative z-10 h-full flex flex-col justify-end p-6 md:p-12">
            <div className="max-w-xl">
              <span className={`inline-block text-xs font-bold tracking-widest uppercase mb-3 ${current.textAccent}`}>
                {current.tagline}
              </span>
              <h3 className="text-4xl md:text-6xl font-extrabold text-white mb-4 leading-tight">
                {current.name}
              </h3>
              <p className="text-white/90 text-sm md:text-base leading-relaxed mb-6 max-w-md">
                {current.description}
              </p>

              {/* Highlights */}
              <div className="flex flex-wrap gap-2 mb-8">
                {current.highlights.map((h) => (
                  <span
                    key={h}
                    className="flex items-center gap-1.5 bg-white/20 backdrop-blur-sm text-white text-xs md:text-sm px-3 py-1.5 rounded-full"
                  >
                    <i className="ri-map-pin-2-fill text-xs"></i>
                    {h}
                  </span>
                ))}
              </div>

              <a
                href="#contacto"
                onClick={(e) => {
                  e.preventDefault();
                  window.dispatchEvent(new CustomEvent('prefill-contact', { detail: { destino: current.name } }));
                  document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 bg-white text-gray-900 font-bold px-6 py-3 rounded-full hover:bg-teal-50 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg text-sm md:text-base"
              >
                View available tours
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </a>
            </div>
          </div>

          {/* Country indicators */}
          <div className="absolute top-6 right-6 z-10 flex gap-2">
            {countries.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setActive(idx)}
                className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
                  active === idx ? 'bg-white scale-125' : 'bg-white/40 hover:bg-white/70'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Bottom cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
          {countries.map((country, idx) => (
            <button
              key={country.id}
              onClick={() => setActive(idx)}
              className={`relative overflow-hidden rounded-2xl h-32 cursor-pointer transition-all duration-300 ${
                active === idx ? 'ring-4 ring-teal-500 scale-[1.02]' : 'hover:scale-[1.01] opacity-80 hover:opacity-100'
              }`}
            >
              <img
                src={country.image}
                alt={country.name}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-black/40"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-4 text-left">
                <span className="text-white font-bold text-lg leading-tight">{country.name}</span>
                <span className="text-white/80 text-xs">{country.tagline}</span>
              </div>
              {active === idx && (
                <div className="absolute top-3 right-3 w-6 h-6 flex items-center justify-center bg-teal-500 rounded-full">
                  <i className="ri-check-line text-white text-xs"></i>
                </div>
              )}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
